/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { AfterViewInit, Component, ElementRef, inject, NgZone, viewChild } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { LayoutAlignDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';

@Component({
    selector: 'dash-gis-report-video',
    templateUrl: './report-video-dialog.component.html',
    imports: [ LayoutDirective, LayoutAlignDirective, MatIconButton, MatDialogClose, MatIcon ]
})
export class ReportVideoDialogComponent implements AfterViewInit {
    target = viewChild<ElementRef<HTMLVideoElement>>('target');
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject(MatDialogRef<ReportVideoDialogComponent>);
    ngZone = inject(NgZone);

    ngAfterViewInit() {
        this.target().nativeElement.load();
    }

    public close() {
        this.ngZone.run(() => this.dialogRef.close());
    }

    get videoSource() {
        return this.data;
    }
}
